import { isNewVariantForStrategy, getNewVariantForStrategyInitialData, isNewStrategyForSegment, getNewStrategyForSegmentInitialData, isNewStrategyForAssetType, getNewStrategyForAssetTypeInitialData, isNewStrategyForUnpersonalizedAsset, getNewStrategyForUnpersonalizedAssetInitialData } from 'personalization-lib/utils/variantCreation/panelPatterns';
export const getInitialPanelData = panelData => {
  if (panelData) {
    if (isNewVariantForStrategy(panelData)) {
      return getNewVariantForStrategyInitialData(panelData);
    }
    if (isNewStrategyForSegment(panelData)) {
      return getNewStrategyForSegmentInitialData(panelData);
    }
    if (isNewStrategyForAssetType(panelData)) {
      return getNewStrategyForAssetTypeInitialData(panelData);
    }
    if (isNewStrategyForUnpersonalizedAsset(panelData)) {
      return getNewStrategyForUnpersonalizedAssetInitialData(panelData);
    }
  }
  return undefined;
};